<script>

  import { External } from '../external';

  export let wrapperClasses = '';
  export let identifier = '';
  export let name = '';

  let initials, color;
  $: {
    const result =
      External.Tools.getColorAndInitialsFromNameAndEmail(name, '' + identifier) ||
      window.Tools.getColorAndInitialsFromNameAndEmail(name, '' + identifier); // so it can work on builder

    initials = result.initials;
    color = result.color;
  }
</script>

<div class="{wrapperClasses} flex align-center justify-center" style="background-color: {color}">
  <span class="contact-initials">{initials.toUpperCase()}</span>
  <slot></slot>
</div>
